import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendCustomer, BackendQueryCustomerArgs } from 'src/types/backend';

import { CUSTOMER_MEMBER_FRAGMENT } from './schema';

const QUERY = gql`
  query CustomerTeamMembers($id: ID!) {
    customer(id: $id) {
      id
      teamMembers {
        ...CustomerMember
      }
    }
  }
  ${CUSTOMER_MEMBER_FRAGMENT}
`;

type Variables = BackendQueryCustomerArgs;
type Result = Pick<BackendCustomer, 'teamMembers'>;

export const queryMembers = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data)?.teamMembers ?? [];
};
